import React, { Component } from 'react';
import { Rect, Text, Group } from 'react-konva';

export class GenericComponentCanvas extends Component {
    render() {
        const { component, isSelected, dimentionsRatio, draggable } = this.props;

        const componentWidth = component.width * dimentionsRatio;
        const componentHeight = component.height * dimentionsRatio;

        const fontSizeComponentSizeRatio = component.text.length / 1.65;

        let fontSize = componentHeight / 2.75;
        let textPosX = component.drawPositionX + 10 * dimentionsRatio;
        let textPoxY = component.drawPositionY + componentHeight - 10 * dimentionsRatio;
        let textRotation = 0;

        if(componentWidth >= componentHeight) {
            if (fontSizeComponentSizeRatio * fontSize > componentWidth) {
                fontSize = componentWidth / fontSizeComponentSizeRatio;
            }

            if(fontSize > componentHeight) {
                fontSize *= componentHeight / fontSize;
            }
            
            textPoxY = component.drawPositionY + componentHeight / 2.0 - fontSize / 2.5;
        }
        else {
            fontSize = componentWidth / 2.5;
            textRotation = -90;

            if (fontSizeComponentSizeRatio * fontSize > componentHeight) {
                fontSize = componentHeight / fontSizeComponentSizeRatio;
            }

            if(fontSize > componentWidth) {
                fontSize *= componentWidth / fontSize;
            }

            textPosX = component.drawPositionX + componentWidth / 2.0 - fontSize / 2.5;
        }        

        return (
            <Group
                offsetX={component.offsetX}
                offsetY={component.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={component.drawPositionX}
                    y={component.drawPositionY}
                    width={component.width * dimentionsRatio}
                    height={component.height * dimentionsRatio}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />
                <Text text={component.text}
                    fontSize={fontSize}
                    rotation={textRotation}
                    x={textPosX}
                    y={textPoxY} />
            </Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/componentCanvas/GenericComponentCanvas.js